import styles from "@components/account/AccountInfo.module.css";
import ClientAvatar from "@components/ClientAvatar";
import AccountForm from "@components/forms/AccountForm";
import Heading2 from "@components/typography/Heading2";
import { GetClientWithAccountQuery } from "@typing/Generated";

type Props = {
  client: GetClientWithAccountQuery["client"];
};

const AccountInfo = ({ client }: Props) => (
  <div className={styles.accountInfo}>
    <div className={styles.infoAvatar}>
      <div className="ion-margin-bottom">
        <ClientAvatar clientId={client.id} firstName={client.firstName} journeyId={null} size="large" />
      </div>
      <div>
        <Heading2 bold color="gray">
          {client.fullName}
        </Heading2>
      </div>
    </div>
    <AccountForm autofocus={false} client={client} />
  </div>
);

export default AccountInfo;
